module.exports = __webpack_public_path__ + "img/logo.a57ff127.png";